export default __webpack_public_path__ + "static/O0015-ee3b7662e092278805489d140f025d1e.png";